/* * @Author: Wei Guojun * @Date: 2021-04-12 17:16:03 * @Last Modified by: Wei
Guojun * @Last Modified time: 2021-12-22 17:46:37 */
<template>
  <div class="packed_index">
    <el-form
      :inline="true"
      :model="searchMsg"
      class="demo-form-inline search"
      size="mini"
    >
      <el-form-item label="创建时间：">
        <!-- <el-select
          v-model="searchMsg.timeType"
          placeholder="请选择"
          style="width: 120px"
        >
          <el-option
            v-for="item in timeArray"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
        <el-date-picker
          style="width: 360px"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="searchMsg.date"
          type="datetimerange"
          align="right"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="limitPicker"
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="打印人：">
        <el-select
          v-model="searchMsg.printer"
          placeholder="请选择"
          class="selectBox"
        >
          <el-option
            v-for="item in printerArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单来源：">
        <el-select
          v-model="searchMsg.order_source"
          placeholder="请选择"
          class="selectBox"
        >
          <el-option
            v-for="item in comSource"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单状态：">
        <el-select
          v-model="searchMsg.order_status"
          placeholder="请选择"
          class="selectBox"
        >
          <el-option
            v-for="item in maiorderArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单搜索：">
        <el-autocomplete
          style="width: 300px"
          :maxlength="20"
          popper-class="my-autocomplete"
          v-model="searchMsg.key_word"
          :fetch-suggestions="querySearch"
          placeholder="收/寄件姓名、手机号、运单号、标记码、批次码"
          @select="handleSelect"
        >
          <!-- <i
            class="el-icon-edit el-input__icon"
            slot="suffix"
            @click="handleIconClick"
          >
          </i> -->
          <template slot-scope="{ item }">
            <div class="name">{{ item }}</div>
          </template>
        </el-autocomplete>
      </el-form-item>
      <el-form-item label="运单状态：">
        <el-select
          v-model="searchMsg.mail_order_status"
          placeholder="请选择"
          class="selectBox"
        >
          <el-option
            v-for="item in maigetArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单创建人：" v-if="$store.state.teamModel=='2'">
        <el-select
          v-model="searchMsg.order_creator"
          placeholder="请选择"
          class="selectBox"
        >
          <el-option
            v-for="item in createrArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="增值服务：">
        <el-select
          v-model="searchMsg.service_type"
          placeholder="请选择"
          class="selectBox"
        >
          <el-option
            v-for="item in addserve"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="快递类型：">
        <el-select
          v-model="searchMsg.express_type"
          placeholder="请选择"
          class="selectBox"
        >
          <el-option
            v-for="item in expressArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="table">
      <div class="topHeader">
        <div>共<span class="total">{{ table_total }}</span>条订单
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-download"
            @click="appExport()"
            style="margin-left: 10px"
            plain
          >导出订单</el-button>
          <el-popover
              placement="bottom"
              width="140"
              trigger="click">
              <ul>
                <li v-for="(item,index) in showrows" :key="index">
                  <el-checkbox v-model="item.show" @change="rowChange">{{item.label}}</el-checkbox>
                </li>
              </ul>
              <el-button
                slot="reference"
                type="primary"
                size="mini"
                icon="el-icon-setting"
                style="margin-left: 10px"
                plain
              >显示字段设置</el-button>
            </el-popover>
        </div>
        <div>
          <el-button
            @click="search('search')"
            :loading="isSearch"
            type="primary"
            size="mini"
            icon="el-icon-search"
            >查询</el-button
          >
          <el-button @click="reset()" type="primary" plain icon="el-icon-refresh" size="mini"
            >重置</el-button
          >
        </div>
       </div> 
      <el-table ref="table" size="mini" :height="tableHeight" v-loading="tableLoading"
      :header-cell-style="{ background: '#EBEEF5', color: '#333' }"
      border stripe fit highlight-current-row :data="tableData" id="tableBox" @sort-change="sortCreatTime">
        <el-table-column label="" align="center" width="50">
            <template slot="header">
              <el-checkbox @change="allCheck" v-model="all"></el-checkbox>
            </template>
            <template slot-scope="scope">
              <div @click="jgIsywyprint(scope.row)">
                <el-checkbox
                  :value="parcel_id_list.includes(scope.row.order_id)"
                  :disabled="scope.row.morder_marking_infos.is_df == 1 || scope.row.morder_marking_infos.is_insured == 1 || scope.row.morder_marking_infos.is_cod == 1 || scope.row.morder_marking_infos.is_return == 1"
                  @change="checkBox(scope.row.order_id, scope.row)"
                ></el-checkbox>                
              </div>
            </template>
        </el-table-column>
        <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
        <el-table-column label="创建时间" align="left" width="96" sortable v-if="showrows[0].show">
            <template slot-scope="scope">
               <span>{{ scope.row.create_time | formatDate }}</span>  
            </template>
        </el-table-column>
        <el-table-column label="打印时间" align="left" width="96" sortable v-if="showrows[1].show">
            <template slot-scope="scope">
               <span>{{ scope.row.print_time | formatDate }}</span>  
            </template>
        </el-table-column>
        <el-table-column label="创建人" align="left" width="80" v-if="showrows[2].show">
            <template slot-scope="scope">
               <span>{{ scope.row.order_creator.name }}</span>  
            </template>
        </el-table-column>        
        <el-table-column label="订单号" prop="order_id" width="150" align="left" v-if="showrows[3].show"></el-table-column>
        <el-table-column label="运单号/标记码" align="left" width="160" v-if="showrows[4].show">
          <template slot-scope="scope">
            <div class="courier">
              <div class="copyCope">
                <span class="sb_pointer" v-if="page_size <= 20">{{ scope.row.mail_no }}</span>
                <el-popover
                  v-else
                  placement="top-start"
                  width="400"
                  trigger="hover"
                  @show="logisShow(scope.row.param,scope.row.print_time)">
                  <div class="steps">
                    <div class="timeLine">
                        <div class="rLine"></div>
                        <div style="font-weight: bold;color: #222222;">{{scope.row.mail_no}}</div>
                        <div class="step" v-for="(item,index) in steps" :key="index">
                          <div class="s_intro">{{item.statusFit}}</div> 
                          <div class="s_step">
                              <p class="ring" :style="{'background':(index==0 ?'#409EFF':'#909399')}"></p>
                              <span class="first">{{item.time | time}}</span><br/>
                              <span class="two">{{item.station_name}}</span>
                              <span class="two">{{item.description}}</span>                         
                          </div>
                        </div>
                    </div>
                  </div>   
                  <span class="sb_pointer" slot="reference">{{ scope.row.mail_no }}</span>
                </el-popover>
                <i class="el-icon-copy-document sb_pointer"
                    v-if="scope.row.mail_no"
                    v-clipboard:copy="scope.row.mail_no"
                    v-clipboard:success="onCopy"
                ></i><br />
                <b v-if="scope.row.is_take_no == 2" style="color:red">{{
                  scope.row.takenoexcept.length > 3 ? "停发区" : scope.row.takenoexcept
                }}</b>
              </div>
              <div v-if="scope.row.order_status == 1">已失效</div>
              <!-- <div v-else style="color:#2288f8">{{scope.row.mail_order_status | filStatus}}</div> -->
              <div v-if="scope.row.printer == 1">待快递员打印</div>
              <div v-if="scope.row.ticket_id">标记码:{{scope.row.ticket_id}}</div>
            </div>
          </template>
        </el-table-column>  
        <el-table-column label="物流状态" align="center" width="80" v-if="showrows[5].show">
            <template slot-scope="scope">
               <span :style="scope.row.mail_order_status | filColor">{{scope.row.mail_order_status | filStatus}}</span>  
            </template>
        </el-table-column>   
        <el-table-column label="物流信息" align="left" width="150" v-if="page_size <= 20">
            <template slot-scope="scope">
              <div v-if="scope.row.mail_order_status == 1" class="sb_pointer">
                  <div>{{scope.row.print_time | formatDate}}</div> 
                  <div>订单已打印,待揽收</div>  
              </div>
              <el-popover
                v-else
                placement="top-start"
                width="400"
                trigger="hover">
                <div class="steps">
                  <div class="timeLine">
                      <div class="rLine"></div>
                      <div style="font-weight: bold;color: #222222;">{{scope.row.mail_no}}</div>
                      <div class="step">
                        <div class="s_intro"></div> 
                        <div class="s_step">
                            <p class="ring" style="background:#409EFF"></p>
                            <span class="first" v-if="scope.row.mail_trace_vo">{{scope.row.mail_trace_vo.scan_time | formatDate}}</span><br/>
                            <!-- <span class="two">{{item.station_name}}</span> -->
                            <span class="two">{{scope.row.mail_trace_vo.copy_writing}}</span>                         
                        </div>
                      </div>
                  </div>
                </div> 
                <div class="sb_pointer" slot="reference">
                  <div v-if="scope.row.mail_trace_vo">{{scope.row.mail_trace_vo.scan_time | formatDate}}</div> 
                  <div style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.mail_trace_vo.copy_writing}}</div>
                </div>
              </el-popover>
            </template>
        </el-table-column> 
        <el-table-column label="寄件信息" align="left" width="80" v-if="showrows[6].show">
          <template slot-scope="scope">
            <el-popover
              placement="top"
              width="200"
              trigger="hover">
              <div style="font-size:small">
                <img :src="scope.row.ys_send_Show ?openLook : closeLook" class="lookImg" @click="look_ys(scope.$index,'sender')"/>
                <span v-if="!scope.row.ys_send_Show">
                  <span>{{ scope.row.sender_name | ysname }}</span>
                  <span class="paddL10">{{ scope.row.sender_phone | ysBill }}</span>
                </span>
                <span v-else>
                  <span>{{scope.row.sender_name}}</span>
                  <span class="paddL10">{{scope.row.sender_phone}}</span>
                </span>
                <br />
                {{ scope.row.sender_province }} {{ scope.row.sender_city }}
                {{ scope.row.sender_district }} {{ scope.row.sender_address }}
              </div>
              <span slot="reference" class="sb_pointer">{{scope.row.sender_name}}</span>
            </el-popover>
          </template>  
        </el-table-column>     
        <el-table-column label="收件信息" align="left" width="200" v-if="showrows[7].show">       
            <template slot-scope="scope">
              <img :src="scope.row.ys_receive_Show ?openLook : closeLook" class="lookImg" @click="look_ys(scope.$index,'receiver')"/>
              <span v-if="!scope.row.ys_receive_Show">
                <span>{{ scope.row.receiver_name | ysname }}</span>
                <span class="paddL10">{{ scope.row.receiver_phone | ysBill }}</span>
              </span>
              <span v-else>
                <span>{{scope.row.receiver_name}}</span>
                <span class="paddL10">{{scope.row.receiver_phone}}</span>
              </span>
              <br />
              {{ scope.row.receiver_province }} {{ scope.row.receiver_city }}
              {{ scope.row.receiver_district }} {{ scope.row.receiver_address }} 
            </template>
        </el-table-column>
        <el-table-column label="物品类型" align="center" width="100" prop="item_type" v-if="showrows[8].show"></el-table-column>
        <el-table-column label="重量" align="center" width="80"  v-if="showrows[9].show">
          <template slot-scope="scope">
              <span>{{ scope.row.goods_weight?scope.row.goods_weight+'KG':''}} </span> 
            </template>
        </el-table-column>
        <el-table-column label="快递类型" align="center" width="100" prop="item_type" v-if="showrows[10].show">
            <template slot-scope="scope">
              <span>{{ scope.row | kdtype}}</span>  
            </template>
        </el-table-column>
        <el-table-column label="备注" align="left" v-if="showrows[11].show">
            <template slot-scope="scope">
               <span>{{ scope.row.item_note || "- -" }}</span>  
            </template>
        </el-table-column>
        <el-table-column label="增值服务" align="left" width="210" v-if="showrows[12].show">
            <template slot-scope="scope">
               <div v-if="scope.row.morder_marking_infos.is_df == 1" >
                <el-tag size="mini" style="margin-right:10px">到付</el-tag>
               </div>
               <div v-if="scope.row.morder_marking_infos.is_insured == 1"><el-tag size="mini">保价</el-tag>
                物品价值{{scope.row.morder_marking_infos.insured_value}}元，保费{{scope.row.morder_marking_infos.insured_pay}}元
               </div>
               <div v-if="scope.row.morder_marking_infos.is_sgj == 1" >
                <el-tag size="mini" style="margin-right:10px">水果件</el-tag>
               </div>
               <div v-if="scope.row.morder_marking_infos.is_cod == 1"><el-tag size="mini">代收</el-tag>
                代收货款{{ scope.row.morder_marking_infos.cod_value}}元，服务费{{scope.row.morder_marking_infos.code_pay}}元
               </div>
               <div v-if="scope.row.morder_marking_infos.is_return == 1"><el-tag size="mini">签单</el-tag>
                返回单号:{{scope.row.morder_marking_infos.return_mail_no}}
                ,签单方式<span v-show ="scope.row.morder_marking_infos.return_value">{{scope.row.morder_marking_infos.return_value | returnValue}}</span>
               </div>
               <span v-if="(
                    scope.row.morder_marking_infos.is_df == 0 && 
                    scope.row.morder_marking_infos.is_sgj == 0 && 
                    scope.row.morder_marking_infos.is_insured == 0 && 
                    scope.row.morder_marking_infos.is_cod == 0 && 
                    scope.row.morder_marking_infos.is_return == 0)"
               >--</span>
            </template>
        </el-table-column>
        <el-table-column label="物品来源" align="left" width="100" v-if="showrows[13].show">
          <template slot-scope="scope">
              <span>{{ scope.row.order_source | comeFrom }}</span>  
          </template>
        </el-table-column>   
        <el-table-column label="付款方式" align="left" width="80" v-if="showrows[14].show">
          <template slot-scope="scope">
              <span>{{ scope.row.morder_marking_infos.is_df == 1 ? '到付':'寄付' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="运费" align="left" width="70" v-if="showrows[15].show">
            <template slot-scope="scope">
               <span>{{ scope.row.daofu_amount ? scope.row.daofu_amount + " 元" : scope.row.daofu_amount }}</span>  
            </template>
        </el-table-column>
        <el-table-column label="批次识别码" align="left" width="100" v-if="showrows[16].show">
            <template slot-scope="scope">
               <span>{{ scope.row.print_serial_no }}</span>  
            </template>
        </el-table-column>
        <el-table-column label="操作" align="center"  width="150" fixed="right">
            <template slot-scope="scope">
              <div class="operation_div">
                <div @click="oneceNew(scope.row)">克隆</div>
                <div v-if="zkRowlist.indexOf(scope.row.order_id) == -1" @click="toogleExpand(scope.row,'展开')">展开详情</div>
                <div v-else @click="toogleExpand(scope.row,'收起')">收起详情</div>
                <el-dropdown size="small" @command="(command)=>{handleCommand(command,scope.row)}">
                <span class="el-dropdown-link" style="font-size:12px">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="scope.row.mail_order_status == 1 && scope.row.order_status == 0" @click="cancelBill(scope.row.order_id)" command="a">取消订单</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.mail_order_status == 1" @click="delBill(scope.row)" command="b">删除订单</el-dropdown-item>
                  <el-dropdown-item @click="print(scope.row)" :disabled="scope.row.order_status == 1 || scope.row.morder_marking_infos.is_df == 1 || scope.row.morder_marking_infos.is_insured == 1 || scope.row.morder_marking_infos.is_cod == 1 || scope.row.morder_marking_infos.is_return == 1" command="c">原单重打</el-dropdown-item>
                  <el-dropdown-item @click="goElectronicSheet(scope.row.order_id)" command="d">电子底单</el-dropdown-item>
                  <el-dropdown-item @click="golog(scope.row.param)" command="e">查看物流</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              </div>
            </template>
        </el-table-column>
        <el-table-column type="expand" width="1" align="center">
          <template slot-scope="props">
            <div class="info">
              <el-row>
                <el-col :span="6">
                  <div class="grid-content">
                    <span>订单号：</span>
                    <span>{{ props.row.order_id }}</span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <span>打印时间：</span>
                    <span>{{props.row.print_time | formatDate}}</span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <span>订单来源：</span>
                    <span>{{props.row.order_source | comeFrom}}</span>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="grid-content">
                    <span>付款方式：</span>
                    <span>{{props.row.morder_marking_infos.is_df == 1 ? '到付':'寄付'}}</span>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="grid-content">
                    <span>运费：</span>
                    <span>{{ props.row.daofu_amount ? props.row.daofu_amount + " 元" : '--'}}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6"  v-if="props.row.morder_marking_infos.is_insured == 1">
                  <div class="grid-content">
                    <span>保价服务：</span>
                    <span>物品价值{{props.row.morder_marking_infos.insured_value}}元，保费{{props.row.morder_marking_infos.insured_pay}}元</span>
                  </div>
                </el-col>
                <el-col :span="6" v-if="props.row.morder_marking_infos.is_cod == 1">
                  <div class="grid-content">
                    <span>代收货款：</span>
                    <span>{{ props.row.morder_marking_infos.cod_value}}元，服务费{{props.row.morder_marking_infos.code_pay}}元</span>
                  </div>
                </el-col>
                <el-col :span="6" v-if="props.row.morder_marking_infos.is_return == 1">
                  <div class="grid-content">
                    <span>签单返回：</span>
                    <span>{{ props.row.morder_marking_infos.return_value | returnValue}},返回单号:{{props.row.morder_marking_infos.return_mail_no}}</span>
                  </div>
                </el-col>
                <!-- <el-col :span="3">
                  <div class="grid-content">
                    <span>智橙网：</span>
                    <span>{{props.row.express_type == 'TK' ? '有':'无'}}</span>
                  </div>
                </el-col> -->
              </el-row>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pages">
      <div class="pages_left"></div>
      <div class="pages_right">
        <el-pagination
          :current-page.sync="currPage"
          :page-size="page_size"
          @size-change="changeSizes"
          :page-sizes="[20, 50, 100, 200, 500]"
          @current-change="currentPage"
          layout="sizes,prev, pager, next, jumper"
          :total="table_total"
        ></el-pagination>
        <div slot="append" class="sure" type="primary">确定</div>
      </div>
    </div>
    <footer>
      <div class="footer">
        <div>
          <div class="allCheck">
            <!-- <el-checkbox @change="allCheck" v-model="all">本页全选</el-checkbox> -->
            <span>已选<b>{{ parcel_id_list.length }}</b></span>
          </div>
          <div class="btn">
            <el-button
              v-if="!nocanPrint"
              class="footBtn"
              @click="repeatPrint()"
              :loading="allPrint"
              icon="el-icon-printer"
              type="primary"
              >批量重新打印(原单号)</el-button
            >
            <el-button v-else class="footBtn" disabled type="info" icon="el-icon-printer"
              >批量重新打印(原单号)</el-button
            >
            <el-button
              class="footBtn"
              @click="delAll()"
              type="primary" plain
              icon="el-icon-delete"
              >批量删除</el-button
            >            
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import print from "@/api/print";
import util from "@/util/util";
import myLocalStorage from "@/util/crypto.js";
import  myMinix  from '@/mixin/minix';
import  teamMix  from '@/mixin/teamMix';
import { PrintWaiting, startPrinting } from '@/util/ptintTool.js';
import request from "@/util/request";
const rowshowArr = [
  {label:'创建时间',show:true},
  {label:'打印时间',show:false},
  {label:'创建人',show:true},
  {label:'订单号',show:false},
  {label:'运单号/标记码',show:true},
  {label:'物流状态',show:true},
  {label:'寄件信息',show:true},
  {label:'收件信息',show:true},
  {label:'物品类型',show:false},
  {label:'重量',show:true},
  {label:'快递类型',show:true},
  {label:'备注',show:true},
  {label:'增值服务',show:true},
  {label:'订单来源',show:false},
  {label:'付款方式',show:false},
  {label:'运费',show:false},
  {label:'批次识别码',show:true}
]
let limitTime = null
export default {
  name: "printed",
  mixins: [myMinix,teamMix],
  data() {
    return {
      tableHeight:300,
      searchMsg: {
        order_creator:0,
        timeType: 2,
        printer: 0, // 打印人
        date: [util.getlimiTime(30) +' 00:00:00', util.getlimiTime(0)+' 23:59:59'],
        sort: 2,
        mail_order_status: '',
        order_status: 0,
        order_source: 0,
        key_word: "", //搜索框
        service_type: "",
        express_type:'',
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date(util.getlimiTime(0) + ' 23:59:59');
              const start = new Date(util.getlimiTime(0) + ' 00:00:00');
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date(util.getlimiTime(0) + ' 23:59:59');
              const start = new Date(util.getlimiTime(0) + ' 00:00:00');
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const end = new Date(util.getlimiTime(0) + ' 23:59:59');
              const start = new Date(util.getlimiTime(0) + ' 00:00:00');
              const nows = start.getDay() || 7;
              start.setTime(start.getTime() - 3600 * 1000 * 24 * (nows - 1));
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              const end = new Date(util.getlimiTime(0) + ' 23:59:59');
              const start = new Date(util.getlimiTime(0) + ' 00:00:00');
              start.setDate(1);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
        disabledDate: (time) => {
          let nowDate = new Date();
          let oneDay = 1000 * 60 * 60 * 24;
          let current_time =  util.getlimiTime(0) + ' 23:59:59'
          let oneMonthLater = new Date(nowDate.getTime() - oneDay * limitTime);
          return time.getTime() > new Date(current_time).getTime() || time.getTime() < oneMonthLater;
        },
      },
      tableData: [], // 数据
      table_index: [], //展开
      table_total: 0, //总数
      page_size: 20,
      currPage: 1, //当前页
      isSearch: false, //搜索中...
      forSearch: false, //是否是搜索
      haveData: true,
      parcel_id_list: [],
      parcel_list: [],
      all: false,
      allPrint: false,
      tableLoading: false,
      maiorderArr: [
        { label: "未取消", value: 0 },
        { label: "已取消", value: 1 },
      ],
      sortList: [
        { label: "打印时间倒序", value: 2 },
        { label: "打印时间正序", value: 1 },
        { label: "创建时间倒序", value: 4 },
        { label: "创建时间正序", value: 3 },
      ],
      timeArray: [
        { label: "打印时间", value: 1 },
        { label: "创建时间", value: 2 },
      ],
      nocanPrint: false, //批量打印是否开启
      first_click: true,
      cooldown: 0,
      Isdesktop: "",
      historyRecord: [],
      zkRowlist:[],
      showrows:rowshowArr,
      steps:[],
    };
  },

  filters: {
    kdtype(row){
      if(row.express_type == 'TK'){
        return '智橙网'
      }else{
        if(row.morder_marking_infos){
           if(row.morder_marking_infos.is_sgj == 1){
             return '水果件'
           }else{
             return '普通快递'
           }    
        }else{
          return '普通快递'
        }
      }  
    },
    formatDate(time) {
      var date = new Date(time);
      return util.formatTime(date, "yyyy-MM-dd hh:mm:ss");
    },
    comeFrom(data) {
      var string = "";
      let map = {101:'寄快递创建',102:'电脑导入',103:'邀请下单',104:'代客下单'}
      string = map[data] || ''
      return string;
    },
    filStatus(data) {
      var string = "";
      let map = {1:'待揽件',2:'已揽件',3:'已签收',4:'运输中'}
      string = map[data] || ''
      return string;
    },
    filColor(data){
      var string = "";
      if([2,4].includes(data)){
        string = 'color:#fabb00'  
      }else if(data == 3){
        string = 'color:#31C964'    
      }else{
        string = 'color:#EF3E3E'
      }
      return string;
    },
    time(data){
      var date = new Date(data);
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1):date.getMonth()+1) + '-';
      var D = (date.getDate()< 10 ? '0'+date.getDate():date.getDate())+ ' ';
      var h = (date.getHours() < 10 ? '0'+date.getHours():date.getHours())+ ':';
      var m = (date.getMinutes() < 10 ? '0'+date.getMinutes():date.getMinutes()) + ':';
      var s = date.getSeconds() < 10 ? '0'+date.getSeconds():date.getSeconds();
      return Y+M+D+h+m+s;
    }
  },
  computed: {
    orderStatus() {
      return this.$store.state.orderStatus.status;
    },
  },
  watch: {
    orderStatus: {
      handler(val) {
        if (val) {
          this.searchMsg.mail_order_status = val;
          this.searchMsg.date = [
            this.$store.state.orderStatus.start
              ? this.$store.state.orderStatus.start
              : "",
            this.$store.state.orderStatus.end
              ? this.$store.state.orderStatus.end
              : "",
          ];
          this.loadData();
        }
      },
      immediate: true,
    },
  },
  beforeCreate() {},
  created() {
    localStorage.getItem("historyPrintedRecord") &&
      (this.historyRecord = JSON.parse(
        localStorage.getItem("historyPrintedRecord")
      ));
  },
  mounted: function () {
    limitTime = util.getJsonValues(this.$store.state.commondict,'print_limited') || 90;
    const Isdesktop = util.getCookie("from"); //是不是桌面
    if (Isdesktop) {
      this.Isdesktop = Isdesktop;
    }
    //数据挂载
    let PrintedRow = util.getCookie('PrintedRow');
    if(PrintedRow){
      this.showrows = JSON.parse(PrintedRow)
    }
    let userset = JSON.parse(this.$store.state.userSet);
    this.searchMsg.sort = userset.printSort || 2;
    this.loadData();
    util.getTableHeight(this,document.getElementById('tableBox'),84) ;
    window.addEventListener('resize',()=>{
      util.getTableHeight(this,document.getElementById('tableBox'),84);     
    });
    window.addEventListener("keydown", this.handkeyCode, true);
  },
  components: {
    //组件声明
    // queryYwy
  },
  beforeDestroy(){
    window.removeEventListener('resize',()=>{
      util.getTableHeight(this,document.getElementById('tableBox'),84);  
    }) 
  },
  methods: {
    logisShow(mailNo,print_time){
      print.logistics(this,mailNo).then(res=>{
        if(res.success){
          this.$nextTick(() => {
            const data = res.data;
            this.steps = data.logistics.steps; 
            this.steps.push({
             time:print_time,
             description:'订单已打印,待揽件',
            })     
          });
        }
      })
    },
    rowChange(){
      util.setCookie('PrintedRow',JSON.stringify(this.showrows))
      this.$nextTick(()=>{
        this.$refs.table.doLayout()
      })
    },
    handleCommand(a,b){
      let row = b;
      if(a== 'a'){
        this.cancelBill(row.order_id) 
      }else if(a== 'b'){
        this.delBill(row)
      }else if(a== 'c'){
        this.print(row)
      }else if(a== 'd'){  
        this.goElectronicSheet(row.order_id)
      }else{
        this.golog(row.param)
      }
    },
    toogleExpand(row, text) {
      let $table = this.$refs.table;
      if (text == "展开") {
        this.tableData.map((item) => {
          if (row.order_id != item.order_id) {
            $table.toggleRowExpansion(item, false)
          }
        })
        this.currentIndex = row.order_id
        this.zkRowlist.push(row.order_id)
      } else {
        this.currentIndex = null;
        let getLocation = this.zkRowlist.indexOf(row.order_id);
        this.zkRowlist.splice(getLocation, 1); 
      }
      $table.toggleRowExpansion(row)
    },
    //查看物流信息
    golog(e) {
      window.open("../../../logistics.html?mailNo=" + e);
    },
    //跳转至电子底单页
    goElectronicSheet(e){
      this.$store.commit("SET_ROUTE_FROM", "/electronicSheet");
      this.$router.push({path:'./electronicSheet',query:{id:e}})
    },
    look_ys(index,type){
      let list = this.tableData
      if(type == 'sender'){
        list[index].ys_send_Show = !list[index].ys_send_Show
      }else{
        list[index].ys_receive_Show = !list[index].ys_receive_Show
      }
      this.tableData = list
    },    
    querySearch(queryString, cb) {
      var restaurants = this.historyRecord;
      // var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(restaurants);
    },
    handleSelect(item) {
      this.searchMsg.key_word = item;
      console.log(item);
    },
    appExport() {
      let nowTime = new Date().getTime() - this.cooldown;
      if (!this.cooldown || nowTime > 2000) {
        const jgsort = util.jgsort(this.searchMsg.sort);
        this.cooldown = new Date().getTime();
        const link = document.createElement("a");
        // let start_time = util.getlimiTime(39) + " 00:00:00";
        // let end_time = util.getlimiTime(0) + " 23:59:59";
        let start_time = '';
        let end_time = '';
        if (this.searchMsg.date == null) {
          this.$message.error('请选择导出时间区间')
          return
        }
        if (this.searchMsg.date[0] && this.searchMsg.date[1]) {
          start_time = this.searchMsg.date[0] || ''
          end_time = this.searchMsg.date[1] || ''
        }
        let linkHref = (
          window.location.origin +
          "/file/downloadOrdersGet?" +
          "accountId=" +
          util.getCookie("account_id") +
          "&keyWord=" +
          this.searchMsg.key_word +
          "&orderType=1" +
          "&orderSource=" +
          this.searchMsg.order_source +
          "&orderStatus=" +
          this.searchMsg.order_status +
          "&printer=" +
          this.searchMsg.printer +
          "&sort=" +
          jgsort[1] +
          "&orderByColumn=" +
          jgsort[0] +
          "&expressType=" + this.searchMsg.express_type +
          "&serviceType=" +
          this.searchMsg.service_type +
          "&mailOrderStatus=" +
          this.searchMsg.mail_order_status +
          "&websocketToken=" +
          util.getCookie("websocket_token")
        ).replace(/\s+/g, "%20");
        if (this.searchMsg.timeType == 1) {
          linkHref +=
            "&startTimePrint=" + start_time + "&endTimePrint=" + end_time;
        } else {
          linkHref += "&startTime=" + start_time + "&endTime=" + end_time;
        }
        console.log(linkHref)
        link.href = linkHref;
        document.body.appendChild(link);
        link.click(); //点击下载
        document.body.removeChild(link); //下载完成移除元素
      } else {
        this.$message.warning("按钮点击过快！");
      }
    },
    showDate(val) {
      const search = this.searchMsg.key_word;
      if (val.indexOf(search) !== -1 && search !== "") {
        return val.replace(
          search,
          '<b style="color:#F56C6C">' + search + "</b>"
        );
      } else {
        return val;
      }
    },
    handkeyCode(e) {
      let key = null;
      if (window.event === undefined) {
        key = e.keyCode;
      } else {
        key = window.event.keyCode;
      }
      if (key === 13) {
        this.search("search");
      }
    },
    //排序更改
    sortCreatTime(object){
      if(object.order == 'descending'){
        object.label == '打印时间' ? this.searchMsg.sort = 2 : this.searchMsg.sort = 3
      }else{
        object.label == '打印时间' ? this.searchMsg.sort = 1 : this.searchMsg.sort = 4
      }
      let userset = JSON.parse(this.$store.state.userSet);
      userset.printSort = this.searchMsg.sort;
      this.$store.commit("SET_USER_SET", JSON.stringify(userset));
      this.loadData();
    }, 
    /**删除订单 */
    delBill(item) {
      this.$confirm(
        "确认删除所选订单吗？删除后已获取的运单号若无揽件数据将于40天后自动回收。",
        "提示",
        {
          confirmButtonText: "确定删除",
          cancelButtonText: "再考虑下",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      )
        .then(() => {
          print.delData(this, item.order_id).then((res) => {
            if (res.success) {
              this.$message({ type: "success", message: "订单删除成功!" });
              this.loadData();
              this.$store.dispatch("getthreeNum");
            }
          });
        })
        .catch(() => {});
    },
    /** 批量删除 */
    delAll() {
      if (!this.parcel_id_list.length) {
        this.$message({
          type: "warning",
          message: "没有选中的要删除的订单",
        });
        return;
      }
      let list = [];
      this.parcel_list.forEach((item) => {
        if (item.mail_order_status == 1) {
          list = [...list, item.order_id];
        }
      });
      const candel = list.length;
      const donotdel = this.parcel_id_list.length - candel;
      this.$confirm(
        '所选订单中<b style="color:red;padding:0 5px">' +
          donotdel +
          '</b>单已揽件不支持删除，可删除<b style="color:red;padding:0 5px">' +
          candel +
          "</b>单，是否确定删除?删除后，订单已获取的运单号若无揽件数据将于40天后自动回收。",
        "提示",
        {
          confirmButtonText: "确定删除",
          cancelButtonText: "再考虑下",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      )
        .then(() => {
          print.batchdel(this, this.parcel_id_list).then((res) => {
            if (res.success) {
              this.parcel_id_list = [];
              this.parcel_list = [];
              this.all = false;
              this.$message({ type: "success", message: "订单删除成功!" });
              this.loadData();
              this.$store.dispatch("getthreeNum");
            }
          });
        })
        .catch(() => {});
    },
    /**取消订单 */
    cancelBill(orderId) {
      this.$confirm(
        "确定取消所选的订单吗?<br/>取消后可在订单状态中选择【已取消】查看取消的订单，已获取的运单号若无揽件数据将于40天后自动回收",
        "提示",
        {
          confirmButtonText: "确定取消订单",
          cancelButtonText: "再考虑下",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      )
        .then(() => {
          print.cancelData(this, orderId).then((res) => {
            if (res.success) {
              this.$message({ type: "success", message: "订单取消成功!" });
              this.loadData();
              this.$store.dispatch("getthreeNum");
            }
          });
        })
        .catch(() => {});
    },
    /** 加载更多 */
    loadData() {
      this.tableLoading = true;
      let self = this;
      print.already(this).then((res) => {
        if (res.success) {
          self.tableLoading = false;
          self.table_total = res.data.total;
          self.$store.state.printedNum = res.data.total;
          let datas = res.data.list;
          datas.forEach((value, key) => {
            value.ys_send_Show = false
            value.ys_receive_Show = false
          });
          self.tableData = datas;
          if (res.data.list.length > 0) {
            this.haveData = true;
          } else {
            this.haveData = false;
          }
          this.$nextTick(()=>{
            this.$refs.table.doLayout()
          })
        }
      });
    },
    /** 展示详情 */
    showDet(index) {
      if (this.table_index.indexOf(index) === -1) {
        this.table_index.push(index);
      } else {
        let idx = this.table_index.indexOf(index);
        if (idx > -1) {
          this.table_index.splice(idx, 1);
        }
      }
    },

    /** 单选单个Box */
    checkBox(e, item) {
      let list = this.parcel_id_list;
      let objList = this.parcel_list;
      if (list.indexOf(e) != -1) {
        list.splice(
          list.findIndex((item) => item === e),
          1
        );
        objList.splice(
          list.findIndex((item) => item === e),
          1
        );
      } else {
        if (item.service_type == "到付") {
          this.$alert("到付单仅支持快递员打印，请提交快递员打印", "提示", {
            confirmButtonText: "我知道了",
            center: true,
            callback: (action) => {
              if (action == "confirm") {
                list.push(e);
                objList.push(item);
              }
            },
          });
        } else {
          list.push(e);
          objList.push(item);
        }
      }

      if (list.length > 0 && list.length < this.tableData.length) {
        this.all = false;
      } else if (list.length == this.tableData.length) {
        this.all = true;
      } else {
        this.all = false;
      }
      this.parcel_id_list = list;
      this.parcel_list = objList;
    },

    /** 全选 */
    allCheck(e) {
      let list = [];
      let objList = [];
      if (e) {
        this.tableData.forEach((item) => {
          console.log(item)
          if (item.order_status == 0 && !(
            item.morder_marking_infos.is_df == 1 || 
            item.morder_marking_infos.is_insured == 1 ||
            item.morder_marking_infos.is_cod == 1 ||
            item.morder_marking_infos.is_return == 1)) {
            list = [...list, item.order_id];
            objList = [...objList, item];
          }
        });
        this.all = true;
      } else {
        this.all = false;
      }
      this.parcel_id_list = list;
      this.parcel_list = objList;
    },
    /** 单个重新打印 */
    print(item) {
      const {lodopStatus,WebSocketstatus,name} = this.$store.state.connetStatus
      if(!lodopStatus || !WebSocketstatus || !name){
        this.$printError(true);
        return
      }

      this.$confirm(
        "此操作补打面单将打印相同单号的面单，注意重复面单发货风险",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.isLoading = true;
          if (this.first_click) {
            this.first_click = false;
            print.prePrintData(this, [item.order_id]).then((res) => {
              this.first_click = true;
              if (res.success) {
                util.gj_message("打印信息已成功提交至"+util.getCookie("defult_print") +"打印,若打印机长时间不出纸，可以F5刷新浏览器后再次操作",2000);
                const result = res.data;
                let that = this;
                PrintWaiting(this).then(res=>{
                  if (res.initPrint) {
                    const pagenum = util.getJsonValues(this.$store.state.commondict,'packsize') - 0 || 10
                    var groupedArray = util.arrayGroup(result, pagenum);
                    for(let i = 0;i< groupedArray.length;i++){
                      print.printData(this,groupedArray[i]).then(res=>{
                        if(res.success){
                          startPrinting(res.data).then(()=>{that.loadData();})
                        }
                      })                
                    }   
                  }
                }) 
              }
            });
          } else {
            this.$message.warning("点击次数过快，请稍后重试");
          }
        })
        .catch(() => {});
    },
    //时间选择器限制
    limitPicker(){
      if(this.searchMsg.date == null){return}
      const start = new Date(this.searchMsg.date[0]).getTime()
      const end = new Date(this.searchMsg.date[1]).getTime()
      if(end - start > 2.6784e9){
        this.$message.error("起始时间与结束时间跨度不可大于31天~");
      }
    },
    /** 搜索 */
    search(flag) {
      const start = new Date(this.searchMsg.date[0]).getTime()
      const end = new Date(this.searchMsg.date[1]).getTime()
      if(end - start > 2.6784e9){
        this.$message.error("起始时间与结束时间跨度不可大于31天~");
        return;
      }
      this.isSearch = true;
      this.forSearch = true;
      this.table_index = [];
      if (flag) {
        var postMsg = {
          current_page: 1,
          page_size: this.page_size,
          print_status: 1,
        };
        this.currPage = 1;
      } else {
        var postMsg = {
          current_page: this.currPage,
          page_size: this.page_size,
          print_status: 1,
        };
      }
      if (this.searchMsg.order_status == 1) {
        this.nocanPrint = true;
      } else {
        this.nocanPrint = false;
      }
      //历史记录
      if (this.searchMsg.key_word != "") {
        // debugger;
        if (this.historyRecord.length >= 5) {
          this.historyRecord.splice(4, 1);
        }
        !this.historyRecord.includes(this.searchMsg.key_word) &&
          this.historyRecord.unshift(this.searchMsg.key_word);
        localStorage.setItem(
          "historyPrintedRecord",
          JSON.stringify(this.historyRecord)
        );
      }
      this.loadData();
      setTimeout(() => {
        this.isSearch = false;
      }, 500);
    },
    /** 重置 */
    reset() {
      this.table_index = [];
      this.searchMsg = {
        timeType: 2,
        printer: 0, // 打印人
        date: [util.getlimiTime(30) +' 00:00:00', util.getlimiTime(0)+' 23:59:59'],
        order_source: 0,
        key_word: "", //搜索框
        sort: 2,
        mail_order_status: '',
        order_status: 0,
        service_type: "",
        express_type:'',
      };
      this.select = "";
      this.forSearch = false;
      this.currPage = 1;
      this.page_size = 20;
      this.loadData();
    },
    /** 改变条数 */
    changeSizes(e) {
      this.page_size = e;
      this.currPage = 1;
      if (this.forSearch) {
        this.search();
      } else {
        this.loadData();
      }
    },
    /** 当前页 */
    currentPage(e) {
      this.currPage = e;
      if (this.forSearch) {
        this.search();
      } else {
        this.loadData();
      }
    },
    /** 一键复制 */
    onCopy(e) {
      this.$message({
        message: "快递单号: " + e.text + " 复制成功",
        type: "success",
      });
    },
    //导出
    exportRecord() {
      if (this.tableData.length <= 0) {
        this.$message({
          message: "您要导出的数据为空，请查询后再试！",
          type: "warning",
        });
        return;
      }
      print.downloadFile(this, 1).then((res) => {
        console.log(res);
      });
    },
    /**批量重新打印 */
    repeatPrint() {
      if (!this.parcel_id_list.length) {
        this.$message({
          type: "warning",
          message: "没有选中的要打印的订单",
        });
        return;
      }
      const {lodopStatus,WebSocketstatus,name} = this.$store.state.connetStatus
      if(!lodopStatus || !WebSocketstatus || !name){
        this.$printError(true);
        return
      }
      
      const orderIds = this.parcel_list.map((el) => {
        return (el = el.order_id);
      });
      console.log(orderIds);
      this.$confirm(
        "已选<span style='color:#ff0000'>" +
          this.parcel_id_list.length +
          "</span>个订单，确认打印已选订单？此操作补打面单将打印相同单号的面单，注意重复面单发货风险",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          this.allPrint = true;
          if (this.first_click) {
            this.first_click = false;
            print.prePrintData(this, this.parcel_id_list).then((res) => {
              this.first_click = true;
              if (res.success) {
                const num = this.parcel_id_list.length - res.data.length
                if (num > 0) {
                  util.gj_message("批量打印存在" + num + "单取号失败无法打印",2000);
                } else {
                  util.gj_message("打印信息已成功提交至" +util.getCookie("defult_print") +"打印,若打印机长时间不出纸，可以F5刷新浏览器后再次操作",2000);
                }
                const result = res.data;
                PrintWaiting(this).then(res=>{
                  if (res.initPrint) {
                    const pagenum = util.getJsonValues(this.$store.state.commondict,'packsize') - 0 || 10
                    var groupedArray = util.arrayGroup(result, pagenum);
                    let that = this;
                    let busParams = groupedArray.map((el=>{
                      return{
                        action:'kdyserver.print.printOrder',
                        data:{
                          account_id: util.getCookie("account_id"),
                          order_ids: el,
                          template_platform:"lodop"
                        }
                      }
                    }))
                    request.post(this,{
                      action:'kdyserver.account.homeBus',
                      data:{
                        'parameters':request.getBusparameters(busParams)
                      }
                      }).then(res=>{
                        if(res.success){
                          let len = busParams.length
                          for(let i = 0 ; i < len; i ++){
                            startPrinting(res.body.data[i].data)
                            if(len == i+1){
                              that.allPrint = false;
                              that.parcel_id_list = [];
                              that.parcel_list = [];
                              that.all = false;
                              that.loadData();
                            }
                          }
                        } 
                      })  
                  }
                })  
              } else {
                this.allPrint = false;
              }
            });
          } else {
            this.$message.warning("单击次数过快，请稍后再试");
          }
        })
        .catch(() => {
          this.allPrint = false;
          this.first_click = true;
        });
    },
    /** 再建一单 */
    oneceNew(data) {
      // console.log('item',data)
      const send = {
        name: data.sender_name, // 姓名
        phone: data.sender_phone, // 手机号
        province: data.sender_province, // 省
        province_code: data.sender_province_code, //省编码
        city: data.sender_city, // 市
        city_code: data.sender_city_code, //市编码
        area_code: data.sender_district_code, //区编码
        area: data.sender_district, //区列表
        address: data.sender_address, // 详细地址
        pca: [
          data.sender_province_code,
          data.sender_city_code,
          data.sender_district_code,
        ],
      };
      const collect = {
        name: data.receiver_name, // 姓名
        phone: data.receiver_phone, // 手机号
        province: data.receiver_province, // 省
        province_code: data.receiver_province_code, //省编码
        city: data.receiver_city, // 市
        city_code: data.receiver_city_code, //市编码
        area_code: data.receiver_district_code, //区编码
        area: data.receiver_district, //区列表
        address: data.receiver_address, // 详细地址
        pca: [
          data.receiver_province_code,
          data.receiver_city_code,
          data.receiver_district_code,
        ],
      };
      if (data.order_source == 101 || data.order_source == 102) {
        const preSave = {
          ruleForm: { send, collect },
          typeContent: util.stringthingType(data.item_type),
          textarea: data.item_note,
          Added_Collect: [],
          daofu_amount: data.daofu_amount,
          service_type: data.service_type,
          express_type: data.express_type,
          pri:data.pri,
          morder_marking_infos:data.morder_marking_infos,
          onceNews:true,
        };
        myLocalStorage.setItem("preSave", JSON.stringify(preSave));
        this.$parent.$refs.menuNav.goPath(0, "/home");
      } else {
        const onceNews = {
          ruleForm: { send, collect },
          typeContent: util.stringthingType(data.item_type),
          textarea: data.item_note,
          daofu_amount: data.daofu_amount,
          service_type: data.service_type,
          express_type: data.express_type,
          pri:data.pri,
          morder_marking_infos:data.morder_marking_infos,
          onceNews:true,
        };
        myLocalStorage.setItem("onceNews", JSON.stringify(onceNews));
        this.$parent.$refs.menuNav.goPath(1, "/customer");
      }
    },
    jgIsywyprint(row) {
      if (row.morder_marking_infos.is_df == 1) {
        this.$message.warning("到付单仅支持快递员打印，请快递员到韵镖侠-协议订单查看本订单");     
      } else if(row.morder_marking_infos.is_insured == 1 || row.morder_marking_infos.is_cod == 1 || row.morder_marking_infos.is_return == 1){
        this.$message.warning("保价、代收货款、签单返回单仅支持快递员打印，请快递员到韵镖侠-协议订单查看本订单");   
      } else {
        return;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.packed_index {
  padding-bottom: 40px;
  .selectBox{
    width: 130px
  }
  .search {
    padding: 10px 40px 0 20px;
    background: #fff;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .input-with-select {
      width: 300px;

      /deep/ .el-select .el-input {
        width: 150px;
        color: #606266;
      }

      /deep/ .el-input-group__prepend {
        background-color: #fff;
      }

      /deep/ .el-input__inner {
        color: #606266;
        padding-right: 16px;
      }
    }
    /deep/ .el-form-item {
      margin-bottom:11px;
      margin-right:40px;
    }
    .operation {
      margin-left: auto;
    }
  }

  .table {
    background: #ffffff;
    padding:0px 20px 4px;
    .topHeader {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 36px;
      font-size:14px;
      margin-bottom:6px;

      >div {
        color: #666666;
        .total {
          color: #409EFF;
          padding:0 6px;
        }
      }

      .sortMethod {
        margin-right: 20px;
        font-size: 14px;
      }

      .export {
        margin-left: 50px;

        a {
          color: #409EFF;
        }
      }
    }
    .headurl{
      width: 24px;
      height: 24px;
      border-radius: 50%;
      vertical-align: text-bottom;
    }
  }

  .pages {
    display: flex;
    justify-content: space-between;
    margin-right 20px;

    .pages_right {
      display: flex;

      .sure {
        display: inline-block;
        width: 48px;
        height: 28px;
        margin: 0 5px;
        font-size: 12px;
        text-align: center;
        line-height: 28px;
        border-radius: 4px;
        border: 1px solid rgba(220, 220, 220, 1);
        cursor: pointer;
      }

      .sure:hover {
        background: #2288f8;
        border: 1px solid #2288f8;
        color: #fff;
      }
    }
  }
}

footer {
  height: 40px;
  position: fixed;
  z-index: 99;
  left: 0;
  bottom: 0;
  right: 0;

  .footer {
    height: 40px;
    line-height: 40px;
    background: #ffffff;
    box-shadow: 1px 0 7px rgba(0, 0, 0, 0.1);
    padding-left: 60px;

    >div {
      width: 1200px;
      margin: 0 auto;
      text-align: center;

      .allCheck {
        float: left;
        span{
          padding-left:10px
          b{
            padding:0 5px;
            color:red
          }
        }
      }
    }

    .btn {
      justify-content: center;
      align-items: center;
      .footBtn{
        margin-right 50px
        padding 8px 20px
      }
    }
  }
}

.operation_div {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;

  div {
    cursor: pointer;
    color: #2288F8;

    &:active {
      transform: scale(0.95);
      background: #fff;
    }
    &:hover{
      background: #fff;
    }
  }
}

.print {
  margin-top: 4px;

  a {
    padding: 4px 20px;
    border-radius: 4px;
    color: #1C8BF6;
    font-size: 14px;
    border: 1px solid #1C8BF6;
  }
  .activeClass {
    color: #ddd;
    border: 1px solid #ddd;
  }
}
.info {
  padding:6px 0px 6px 50px;
  width: 1000px;
  box-size:boder-box;
  .info_left {
    flex: 1;
    display: flex;
    align-items: center;
    text-align: left;

    .el-row {
      margin-bottom: 10px;
    }

    >div {
      padding-left: 40px;
      width: 80%;

      .grid-flex {
        display: flex;

        & span:nth-child(1) {
          flex-basis: 15%;
        }

        & span:nth-child(2) {
          flex-basis: 85%;
        }
      }

      .grid-flex2 {
        display: flex;

        & span:nth-child(1) {
          flex-basis: 8%;
        }

        & span:nth-child(2) {
          flex-basis: 92%;
        }
      }

      span {
        color: #000;
      }
    }
  }

  .info_right {
    flex-basis: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2288F8;

    >div {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      &:active {
        transform: scale(0.95);
      }

      img {
        width: 12px;
        height: 6px;
        margin-left: 8px;
      }
    }
  }
}
.copyCope{
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
}
.lookImg{
  width: 14px;
  height: 10px;
  display: inline-block;
  cursor: pointer;
}
.sb_pointer{
 cursor: pointer;
}
.steps{
  font-size: 12px;
  max-height: 300px;
  overflow-y: auto;
  .timeLine {
      position: relative;
      margin-bottom: 20px;
      overflow: hidden;
      .rLine {
          position: absolute;
          border-left: 2px solid #909399;
          float: left;
          height: 100%;
          margin-top: 26px;
          margin-left: 6px;
      }
      .step{
          line-height: 14px;
          margin-bottom: 10px;
          display: flex;
          justify-content: flex-start;
          .s_intro{
            padding-right: 20px;
            line-height: 20px;
          }
          .s_step{
            flex 1
          }
          .ring{
              width: 10px;
              height: 10px;
              border-radius: 50%;
              float left
              position relative
              z-index 9
              margin-top: 8px;
              margin-left: -18px;
          }
          .first{
              color:#222222;
          }
          .two{

          }
      }
  }
}
</style>
<style lang="stylus">
.my-autocomplete{
  .el-autocomplete-suggestion__list::before{
    content:'搜索历史';
    padding-left:20px;
  }
}
.el-table .cell{
  line-height: 16px;
}
#tableBox{
    .el-table__body-wrapper::-webkit-scrollbar {
      width: 10px;
      height:10px;
    }
    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      border-radius: 6px;
      height: 50px;
      background: rgba(0, 0, 0, 0.2);//滚动条颜色
    }
    .el-table__body-wrapper::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 6px;
      background: #eee;//滚动条背景色
    } 
}
.el-table__fixed-body-wrapper .info{
  visibility: hidden;
}
.paddL10{
  padding-left:10px;
}
</style>
